import React, { FunctionComponent } from 'react';
import { ItemMenu } from './Menu';
import { NavbarUlSmall } from './leftAppSidebarStyles';
import type { SidebarMenuItemsProps } from './leftAppSidebarTypes';

type SmallMenuProps = SidebarMenuItemsProps;

const ContainerSmallMenu = (itemMenu: ItemMenu, goToMenu: (item: ItemMenu) => any) => {
    return null;
};

const SmallMenu: FunctionComponent<SmallMenuProps> = (props) => {
    return (
        <React.Fragment>
            <NavbarUlSmall>{ContainerSmallMenu(props.currentMenu, props.goToMenu)}</NavbarUlSmall>
        </React.Fragment>
    );
};

export default SmallMenu;
